export const CARD_STATES = { IDLE: 'idle', LOADING: 'loading', SUCCESS: 'success', ERROR: 'error' };

// Legacy — keep for backward compat in index.jsx wiring
export const SUBMISSION_STEPS = { VALIDATING: 'validating', WARNING_14DAYS: 'warning_14days', CONSENT_REQUIRED: 'consent_required', SUBMITTING: 'submitting', SUCCESS: 'success', ERROR: 'error' };

// New sequential progress phases: Processing → Validating → Submitting → Result
export const SUBMISSION_PHASES = {
    PROCESSING: 'processing',
    VALIDATING: 'validating',
    SUBMITTING: 'submitting',
    SUCCESS: 'success',
    ERROR: 'error',
};

export const PANEL_WIDTH = 300;

export const BASE_URL_GET_ALLCOURSE_VERSIONS = 'course/getCourseVersion/';
export const VALIDATE_COURSE_SUBMISSION_URL = 'user/validate-course-submission';
export const COURSE_ENROLLMENT_URL = 'user/course-version-enrollment';
export const URL_UPDATE_TP_CONSENT = 'user/update-training-provider-consent';

export const injectKeyframes = () => {
    if (typeof document === 'undefined' || document.getElementById('cvd-keyframes')) return;
    const s = document.createElement('style');
    s.id = 'cvd-keyframes';
    s.innerHTML = `
        @keyframes cvdPulse {
            0%, 100% { border-color: #1565c0; }
            50%       { border-color: #90caf9; }
        }
        @keyframes cvdScaleIn {
            from { transform: scale(0); opacity: 0; }
            to   { transform: scale(1); opacity: 1; }
        }
        @keyframes cvdFadeIn {
            from { opacity: 0; }
            to   { opacity: 1; }
        }
        @keyframes cvdSlideUp {
            from { transform: translateY(20px); opacity: 0; }
            to   { transform: translateY(0); opacity: 1; }
        }
        @keyframes cvdStepEnter {
            from { transform: translateX(-12px); opacity: 0; }
            to   { transform: translateX(0); opacity: 1; }
        }
    `;
    document.head.appendChild(s);
};